export default {
  props: ['item'],
  data () {
    return {
      qty: '0',
      sum_price: 0,
      modal_price: 0,
      price_start: 0,
      range_qty: 0,
      temp_pice: 0,
      select_choice: {
        name: '',
        item_barcode: '',
        unit_code: '',
        price: 0,
        normal_price: 0
      },
      header: {
        headers: {
          'Access-Token': sessionStorage.token
        }
      }
    }
  },
  methods: {
    selectPrice (data) {
      // console.log(this.item)
      if (data !== undefined) {
        this.qty = this.item.qty
        this.select_choice.name = this.item.name
        this.select_choice.item_barcode = data.barcode
        this.select_choice.unit_code = data.unit_code
        this.select_choice.normal_price = data.price_1
        // this.modal_price = this.item.price
        this.modal_price = data.price_1
        this.sum_price = parseFloat(this.modal_price) * parseFloat(this.qty)
        this.temp_pice = parseFloat(this.item.total_amount)
      }
      // console.log(this.temp_pice)
    },
    addQTY (str) {
      if (typeof this.qty === 'number') {
        this.qty = ''
      }
      this.qty = this.qty.toString()
      if (str !== '.') {
        if (this.qty === '0') { this.qty = '' }
      }
      this.qty += str
      this.calItemAmount()
    },
    removeQTY () {
      var strQty = this.qty.toString()
      if (strQty.length > 0) {
        this.qty = this.qty.substring((strQty.length - 1), 0)
        if (this.qty.length === 0) {
          this.qty = '0'
        }
        this.calItemAmount()
      }
    },
    addPrice (str) {
      if (this.modal_price === '0' || typeof this.modal_price === 'number') {
        this.modal_price = ''
      } else {
        this.modal_price = this.modal_price.toString()
      }
      this.modal_price += str
      this.calItemAmount()
    },
    removePrice () {
      this.modal_price = this.modal_price.toString()
      if (this.modal_price.length > 0) {
        this.modal_price = this.modal_price.substring((this.modal_price.length - 1), 0)
        if (this.modal_price.length === 0) {
          this.modal_price = '0'
        }
        this.calItemAmount()
      }
    },
    calItemAmount () {
      let remainQty = 0
      let remainPrice = 0
      let rangePriceUse = 0
      if (this.range_qty > 0) {
        remainQty = parseFloat(this.qty) - parseFloat(this.range_qty)
        rangePriceUse = parseFloat(this.price_start) * parseFloat(this.range_qty)
        remainPrice = parseFloat(remainQty) * parseFloat(this.modal_price)
        this.sum_price = Math.ceil(parseFloat(rangePriceUse) + parseFloat(remainPrice))
      } else {
        this.sum_price = Math.ceil(parseFloat(this.modal_price) * parseFloat(this.qty))
      }
    },
    checkMin (val) {
      // console.log(val, this.qty)
      if (parseFloat(val) > parseFloat(this.qty)) {
        this.range_qty = this.qty
      }
      this.calItemAmount()
    },
    submit () {
      var ch = this.$store.state.item_subs.findIndex(row =>
        row.item_barcode === this.select_choice.item_barcode &&
        row.unit_code === this.select_choice.unit_code
      )
      var obj = {
        'name': this.select_choice.name,
        'unit_code': this.select_choice.unit_code,
        'item_barcode': this.select_choice.item_barcode,
        'qty': parseFloat(this.qty),
        'price': parseFloat(this.modal_price),
        'normal_price': this.select_choice.normal_price,
        'total_amount': parseFloat(this.sum_price)
      }
      if (ch > -1) {
        console.log(this.sum_price)
        this.$store.state.item_subs[ch]['qty'] = parseFloat(this.qty)
        this.$store.state.item_subs[ch]['price'] = parseFloat(this.modal_price)
        if (this.range_qty > 0) {
          this.$store.state.item_subs[ch]['total_amount'] = Math.ceil(parseFloat(this.sum_price))
          this.modal_price = this.sum_price / this.qty
          this.$store.state.item_subs[ch]['price'] = parseFloat(this.modal_price)
          this.$store.state.item_subs[ch]['description'] = String(this.qty) + ' x ' + String(this.modal_price)
        } else {
          this.$store.state.item_subs[ch]['total_amount'] = Math.ceil(this.$store.state.item_subs[ch]['qty'] * this.$store.state.item_subs[ch]['price'])
          this.$store.state.item_subs[ch]['description'] = ''
        }
      } else {
        this.$store.state.item_subs.push(obj)
      }
      console.log(this.sum_price)
      console.log(this.temp_pice)
      this.$store.state.order_data.item_amount -= this.temp_pice
      // this.$store.state.item_subs.forEach(val => {
      // if (this.range_qty > 0) {
      //   this.$store.state.order_data.item_amount += Math.ceil(parseFloat(this.sum_price))
      // } else {
      //   // this.$store.state.order_data.item_amount += Math.ceil(val['qty'] * val['price'])
      //   this.$store.state.order_data.item_amount += Math.ceil(parseFloat(this.modal_price) * parseFloat(this.qty))
      // }
      // })
      this.$store.state.order_data.item_amount += Math.ceil(parseFloat(this.sum_price))
      console.log(this.$store.state.order_data.item_amount)
      setTimeout(() => {
        this.price_start = 0
        this.range_qty = 0
      }, 300)
      $('#itemDetailScan').modal('hide')
      $('#itemDetail').modal('hide')
    }
  },
  mounted () {
    $('body').on('hidden.bs.modal', function () {
      $(this).removeData('bs.modal')
      this.qty = '0'
      this.sum_price = '0'
      this.modal_price = '0'
      this.select_choice = {
        name: '',
        item_barcode: '',
        unit_code: '',
        price: 0,
        normal_price: 0
      }
    }.bind(this))
    $('body').on('show.bs.modal', function () {
      this.qty = '0'
      this.sum_price = '0'
      this.modal_price = '0'
      this.select_choice = {
        name: '',
        item_barcode: '',
        unit_code: '',
        price: 0,
        normal_price: 0
      }
      setTimeout(() => {
        this.selectPrice(this.item.item_data.bar_data[0])
      }, 100)
    }.bind(this))
  }
}



// WEBPACK FOOTER //
// ./src/assets/js/pos/item_detail.js